var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home"},[_vm._l((_vm.pageData[0].gblocks),function(block,index){return [_c('div',{key:index,staticClass:"block",domProps:{"innerHTML":_vm._s(block.innerContent[0])}})]})],2),(_vm.$route.name === 'Home')?_c('div',{staticClass:"pCards"},[_c('Post')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }